import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import P from '@deliveroo/consumer-component-library/components/P';
import ModalFooter from '../ModalFooter';

import i18n from '../../utils/i18n';

export function formatTextWithEmail(text, { email, subject, emailText }) {
  // This function replaces the email in the text with a linked version.
  const linkInsertedText = text.split(email).reduce((result, current, index, array) => {
    const linkKey = `link-${index}`;
    const body = emailText ? emailText.split('\\n').join('\n') : undefined;

    const linkText = (
      <a
        key={linkKey}
        href={`mailto:${email}?${queryString.stringify({ subject, body })}`}
        target="_top"
      >
        {email}
      </a>
    );
    const textKey = `${current}-${index}`;
    const currentText = <span key={textKey}>{current}</span>;

    return [...result, currentText, index < array.length - 1 ? linkText : null];
  }, []);

  return linkInsertedText;
}

/**
 * A generic dynamic actions template to render a message to email an email.
 */
function OrderHelpTemplateEmail({
  iframe,
  data: { email, subject, emailText },
  hideFooterPrevious,
  finishInteraction,
}) {
  return (
    <Fragment>
      <P spacing={`0 ${iframe ? 'x-large' : 'medium'}`}>
        {formatTextWithEmail(`Email ${email}`, {
          email,
          subject,
          emailText,
        })}
      </P>

      <ModalFooter
        modal={iframe}
        onSubmit={finishInteraction}
        cta={i18n.gettext('Done')}
        hidePrevious={hideFooterPrevious}
      />
    </Fragment>
  );
}

OrderHelpTemplateEmail.propTypes = {
  /**
   * Whether to style the template appropriately for a modal.
   */
  iframe: PropTypes.bool.isRequired,
  /**
   * Template data to fill out the generic template.
   */
  data: PropTypes.shape({
    email: PropTypes.string.isRequired,
  }),
  /**
   * Whether to hide the previous button for the footer
   */
  hideFooterPrevious: PropTypes.bool,
  /**
   * The action that will be triggered when finishing the interaction.
   */
  finishInteraction: PropTypes.func.isRequired,
};

OrderHelpTemplateEmail.defaultProps = {
  data: {},
  hideFooterPrevious: true,
};

export default OrderHelpTemplateEmail;
